import { render, staticRenderFns } from "./CancelLocation.vue?vue&type=template&id=20f6c9dc&"
import script from "./CancelLocation.vue?vue&type=script&lang=js&"
export * from "./CancelLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports